import request from '@/http/request'

export const setPrintConfig = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/printer/config`, params, {
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}
export const getPrintConfig = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/printer/get`, {
    params,
    nfc: true,
    noSpin: true,
    headers: queryHeader
  })
}
export const checkPrinterStatus = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/printer/checkPrinterStatus`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const getPlantByIp = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/printer/getPlantByIp`, {
    params,
    nfc: true,
    noSpin: true,
    headers: queryHeader
  })
}

export const relabelValidUpc = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/relabel/validUpc`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}

export const relabelValidQrCode = (params, queryHeader) => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/relabel/validQR`, {
    params,
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}
export const relabelPrint = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/relabel/reprint`, params, {
    nfc: true,
    // noSpin: true,
    headers: queryHeader
  })
}
export const getSiteList = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/rfid-report-service/relabel/report/siteList`, {
    nfc: true
  })
}
export const getReportPageList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/relabel/report/page`, params)
}
export const getReportSummaryList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/relabel/report/summary`, params)
}
export const exportReport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/rfid-report-service/relabel/report/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
// 获取打印机ZPL指令
export const getReprintInfo = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-clc-service/api/clc/relabel/getReprintInfo`, params)
}
